module.exports = __webpack_public_path__ + "static/media/orchestra_w_1440.976567eb.jpg";